import Vue from 'vue';

window.Vue = require('vue');

/**
 * Initializes vue and all its components
 */
function initUrlBuilder() {
    Vue.component('url-builder', require('./UrlBuilder.vue').default);
    Vue.component('url-parameter', require('./UrlParameter.vue').default);
    Vue.component('url-result', require('./UrlResult.vue').default);
    Vue.component('url-source', require('./UrlSource.vue').default);
    Vue.component('builder-row', require('./BuilderRow.vue').default);
    Vue.component('button-remove', require('./ButtonRemove.vue').default);

    const app = new Vue({
        el: '#url-builder-wrapper'
    });
}

if (document.readyState !== "loading") initUrlBuilder();
else document.addEventListener("DOMContentLoaded", initUrlBuilder);